import styled from "styled-components";

export const Image = styled.img`
    width: 100%;
`;

export const Flex = styled.div`
    display: flex;
    > div {
        flex: 1;
    }
`;

export const Content = styled.div`
    p {
        margin: 4px 0;
    }
    ul {
        margin: 8px 0;
    }
`;
